// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEpmMasterVddsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListEpmMasterVddsQuery = { __typename?: 'Query' } & {
  listEpmMasterVdds: { __typename?: 'ListEpmMasterVdds' } & Pick<Types.ListEpmMasterVdds, 'totalCount'> & {
      items: Array<
        { __typename?: 'EpmMasterVdd' } & Pick<
          Types.EpmMasterVdd,
          'id' | 'name' | 'enabled' | 'sortOrder' | 'createdAt' | 'updatedAt'
        > & {
            usageStats: { __typename?: 'EpmMasterVddUsageStats' } & Pick<
              Types.EpmMasterVddUsageStats,
              'businessUnitCount' | 'employeeAllocationCount'
            >;
          }
      >;
    };
};

export const ListEpmMasterVddsDocument = /*#__PURE__*/ gql`
    query listEpmMasterVdds($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String) {
  listEpmMasterVdds(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword}
  ) {
    items {
      id
      name
      enabled
      sortOrder
      createdAt
      updatedAt
      usageStats {
        businessUnitCount
        employeeAllocationCount
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListEpmMasterVddsQuery__
 *
 * To run a query within a React component, call `useListEpmMasterVddsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEpmMasterVddsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEpmMasterVddsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListEpmMasterVddsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>(ListEpmMasterVddsDocument, options);
}
export function useListEpmMasterVddsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>(
    ListEpmMasterVddsDocument,
    options,
  );
}
// @ts-expect-error
export function useListEpmMasterVddsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>;
export function useListEpmMasterVddsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEpmMasterVddsQuery | undefined, ListEpmMasterVddsQueryVariables>;
export function useListEpmMasterVddsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEpmMasterVddsQuery, ListEpmMasterVddsQueryVariables>(
    ListEpmMasterVddsDocument,
    options,
  );
}
export type ListEpmMasterVddsQueryHookResult = ReturnType<typeof useListEpmMasterVddsQuery>;
export type ListEpmMasterVddsLazyQueryHookResult = ReturnType<typeof useListEpmMasterVddsLazyQuery>;
export type ListEpmMasterVddsSuspenseQueryHookResult = ReturnType<typeof useListEpmMasterVddsSuspenseQuery>;
